import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles,styled} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import ProfilePhotoButton from '../components/PhotoProfileButton';
import {connect} from 'react-redux';
import {PutSecurityProfileImage, PutSecurityProfilePhoto} from '../../services/SecurityService';
import CustomTabs from './CustomTabs';
import {login} from '../../config/redux/actions/securityActions';

import  { Redirect } from 'react-router-dom'

import Grid from '@material-ui/core/Grid';
import ButtonGroup from '@material-ui/core/ButtonGroup';

import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import NavigationIcon from '@material-ui/icons/Navigation';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

const styles = theme => ({
    card: {
        display: 'flex', 
       flexDirection: 'column',
       alignItems: 'center',
       
    },
    button: {
        display: 'flex',
        flex: 'auto',
        flexDirection: 'column',
         alignItems: 'center',
         brackground: '#45AA36',
         backgroundImage: "url(" + "https://uploads-ssl.webflow.com/5ec207a448d573153616868a/60e32be82622dcd5ebd971ab_Mesh%2075.jpg" + ")",
        
    },
    buttonOption: {
        display: 'flex',
      
    },
});

let ColorButton = styled(Button)(({ theme }) => ({
    color: '#4885ed',
    borderColor: '#4885ed',
    '&:hover': {
      backgroundColor: '#4885ed',
      color:'#ffffff'
    },
  }));

class CardUserPhoto extends Component {
    constructor(props){
        super(props);

        this.state = {
            indexTab: 0
        };
    }

    render(){
        const { classes,
               
                buttons,
                onClick} = this.props;
  
        
        return(
        <div >
            <Card className={classes.card} >
  

                <Grid container spacing={3}>
      
                <Grid item xs={12}>
  <ButtonGroup fullWidth aria-label="full width outlined button group" variant="outlined" size="small">
    {
      buttons == undefined || buttons.map((buttonTitle, index) => (
        ColorButton = styled(Button)(({ theme }) => ({
         
          '&:hover': {
            backgroundColor: buttonTitle.colorletra,
            color: '#ffffff'
          },
          '&:active': {
            backgroundColor: buttonTitle.colorletra,
            color: '#ffffff'
          },
          '&:focus': {
            backgroundColor: buttonTitle.colorletra,
            color: '#ffffff'
          },
          // Cambiar color inverso si el botón está seleccionado
          ...(this.props.index == index 
            ? {
                backgroundColor:buttonTitle.colorletra,
                color: 'white',
                textTransform: 'none',
              }
            : {
                // Estilos para cuando selectedIndex no coincide con buttonTitle.index
                // Por ejemplo:
                color: buttonTitle.colorletra,
                borderColor: buttonTitle.colorletra,
                textTransform: 'none',
              })

        })),
        <ColorButton
          variant="outlined"
          onClick={(event) => { onClick(event, index); this.props.aP();}}
          style={{ fontSize: buttonTitle.nombre.length > 14 ? 13 : 17 }}
        >
          {buttonTitle.icono} &nbsp;&nbsp; {buttonTitle.nombre}
        </ColorButton>
      ))
    }
  </ButtonGroup>
</Grid>

    </Grid>
            </Card>
        </div>
        );
    }
}

CardUserPhoto.propTypes = {
    classes: PropTypes.object.isRequired,
    urlPhoto: PropTypes.string,
    urlAvatar: PropTypes.string,
    userName: PropTypes.string,
    buttons: PropTypes.object,
    onClick: PropTypes.func
};

const mapStateToProps = (state, props) => {
    return {
        user: state.security
    };
};

const mapDispatchToProps = {
    login
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CardUserPhoto));